export default "__VITE_ASSET__DKo4nY0u__"